import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UiState {
  isChatbotOpen: boolean;
}

const initialState: UiState = {
  isChatbotOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setChatbotOpen(state, action: PayloadAction<boolean>) {
      state.isChatbotOpen = action.payload;
    },
  },
});

export const { setChatbotOpen } = uiSlice.actions;
export default uiSlice.reducer;